import React from 'react';
import LeadMagnetSearch from './LeadMagnetSearch';

const Hero: React.FC = () => {
  return (
    <div className="relative pt-24 pb-16 sm:pt-32 sm:pb-24 lg:pb-32 overflow-hidden bg-slate-900">
      {/* Background Gradient - Blue not Purple */}
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900 via-sky-950/20 to-slate-900 pointer-events-none" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-12">
          
          <div className="inline-flex items-center px-4 py-1.5 rounded-full border border-emerald-500/30 bg-emerald-500/10 text-emerald-400 text-xs font-bold mb-8 uppercase tracking-widest">
            <span className="flex h-2 w-2 rounded-full bg-emerald-500 mr-2 animate-pulse"></span>
            Geo-Located Professional Index
          </div>

          <h1 className="text-5xl tracking-tight font-black text-white sm:text-6xl md:text-7xl mb-6">
            The Definitive Database of<br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-sky-400 to-cyan-300">
              Local Licensed Pros.
            </span>
          </h1>
          
          <p className="mt-4 max-w-2xl mx-auto text-xl text-slate-300">
            Target Real Estate Agents, Dentists, and Brokers by <strong>Precise Location</strong> and <strong>License Status</strong>.
            <br className="hidden sm:block" />
            Stop guessing with generic business lists. Know exactly who is Active.
          </p>
        </div>

        {/* LEAD MAGNET SEARCH SECTION */}
        <div className="mt-8 mb-16">
          <LeadMagnetSearch />
        </div>

      </div>
    </div>
  );
};

export default Hero;